import React from "react";
import Box from "@mui/material/Box";
import { TextField, Grid, Typography } from "@mui/material";
import { promoDateToMs } from "../../services/textUtils";

type Props = {
  formik: any;
  disabled?: boolean;
};





const toDateInput = (val: number | string | null | undefined) => {
  const ms = promoDateToMs(val);
  if (ms === null) return "";
  const d = new Date(ms);
  return Number.isNaN(d.getTime()) ? "" : d.toISOString().slice(0, 10);
};

const InventoryStep = ({ formik, disabled = false }: Props) => {
  const { values, touched, errors, handleChange, handleBlur, setFieldValue } = formik;

  const handleDateChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setFieldValue(field, val ? new Date(val).getTime() : null);
  };

  return (
    <Box sx={{ maxWidth: 720 }}>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Stock Quantity"
            name="stock"
            type="number"
            value={values.stock}
            onBlur={handleBlur}
            onChange={handleChange}
            error={touched.stock && Boolean(errors.stock)}
            helperText={touched.stock && errors.stock}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Weight (kg)"
            name="weight"
            type="number"
            value={values.weight}
            onBlur={handleBlur}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        Shipping & Delivery
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Delivery Charges (Rs)"
            name="deliveryCharges"
            type="number"
            value={values.deliveryCharges}
            onBlur={handleBlur}
            onChange={handleChange}
            error={touched.deliveryCharges && Boolean(errors.deliveryCharges)}
            helperText={touched.deliveryCharges && errors.deliveryCharges}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Delivery Days"
            name="deliveryDays"
            type="number"
            value={values.deliveryDays}
            onBlur={handleBlur}
            onChange={handleChange}
            error={touched.deliveryDays && Boolean(errors.deliveryDays)}
            helperText={touched.deliveryDays && errors.deliveryDays}
          />
        </Grid>
      </Grid>

      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        Promotion Window (optional)
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Promo Start Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={toDateInput(values.promoStartDate)}
            onChange={handleDateChange("promoStartDate")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Promo End Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={toDateInput(values.promoEndDate)}
            onChange={handleDateChange("promoEndDate")}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InventoryStep;
